(() => {
  const init = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const variants = JSON.parse(root.querySelector('[data-buybox-variants]').textContent);
    const optionGroups = [...root.querySelectorAll('[data-option-position]')];
    const submit = root.querySelector('[data-buybox-submit]');
    const submitText = root.querySelector('[data-buybox-submit-text]');
    const spinner = root.querySelector('[data-buybox-spinner]');
    const message = root.querySelector('[data-buybox-message]');
    const qtyInput = root.querySelector('[data-quantity-input]');
    const price = root.querySelector('[data-buybox-price]');
    const comparePrice = root.querySelector('[data-buybox-compare-price]');
    const discountBadge = root.querySelector('[data-buybox-discount-badge]');
    const discountValue = root.querySelector('[data-buybox-discount-value]');
    const image = root.querySelector('.canivoa-blog-buybox__image');
    const currency = root.dataset.currency || 'EUR';

    const money = (cents) => new Intl.NumberFormat('de-DE', {
      style: 'currency', currency
    }).format((Number(cents) || 0) / 100);

    const selections = () => optionGroups.map(group => {
      const selected = group.querySelector('.is-selected');
      return selected ? selected.dataset.optionValue : null;
    });

    const currentVariant = () => {
      const selected = selections();
      return variants.find(variant => variant.options.every((value, index) => value === selected[index]));
    };

    const updateAvailability = () => {
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach(button => {
          const testSelections = selections();
          testSelections[groupIndex] = button.dataset.optionValue;
          const possible = variants.some(variant => variant.available && variant.options.every((value, index) => {
            return index === groupIndex || testSelections[index] == null || value === testSelections[index];
          }) && variant.options[groupIndex] === button.dataset.optionValue);
          button.classList.toggle('is-unavailable', !possible);
        });
      });
    };

    const updateUI = () => {
      const variant = currentVariant();
      if (!variant) {
        submit.disabled = true;
        submitText.textContent = 'Nicht verfügbar';
        return;
      }
      price.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePrice.textContent = money(variant.compare_at_price);
        comparePrice.hidden = false;
        const percentage = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        if (discountValue) discountValue.textContent = percentage;
        if (discountBadge) discountBadge.hidden = false;
      } else {
        comparePrice.hidden = true;
        if (discountBadge) discountBadge.hidden = true;
      }
      if (image && variant.image) image.src = variant.image;
      submit.disabled = !variant.available;
      submitText.textContent = variant.available ? 'Ins Warenkörbchen' : 'Ausverkauft';
      updateAvailability();
    };

    optionGroups.forEach(group => {
      group.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');
        if (!button) return;
        group.querySelectorAll('[data-option-value]').forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        message.textContent = '';
        updateUI();
      });
    });

    root.querySelector('[data-quantity-minus]').addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    root.querySelector('[data-quantity-plus]').addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
    });
    qtyInput.addEventListener('change', () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    });

    submit.addEventListener('click', async () => {
      const variant = currentVariant();
      if (!variant || !variant.available || submit.disabled) return;

      submit.disabled = true;
      spinner.hidden = false;
      submitText.textContent = 'Wird hinzugefügt …';
      message.textContent = '';
      message.className = 'canivoa-blog-buybox__message';

      try {
        if (window.Alpine?.store('xCartHelper')?.waitForCartUpdate) {
          await window.Alpine.store('xCartHelper').waitForCartUpdate();
        }
        window.updatingCart = true;
        const sections = window.Alpine?.store('xCartHelper')?.getSectionsToRender?.().map(section => section.id) || [
          'cart-icon-bubble', 'mobile-cart-icon-bubble', 'cart-icon-bubble-mobile-dock', 'cart-drawer'
        ];

        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: Math.max(1, parseInt(qtyInput.value, 10) || 1) }],
            sections
          })
        });
        const result = await response.json();
        if (!response.ok || result.status === 422) throw new Error(result.description || result.message || 'Das Produkt konnte nicht hinzugefügt werden.');

        const cartHelper = window.Alpine?.store('xCartHelper');
        if (cartHelper?.reRenderSections) await cartHelper.reRenderSections(result.sections);
        if (cartHelper && document.querySelector('#cart-icon-bubble span')) {
          cartHelper.currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').textContent, 10) || 0;
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

        message.textContent = '✓ Zum Warenkorb hinzugefügt.';
        message.classList.add('is-success');

        const cartNoti = window.Alpine?.store('xCartNoti');
        if (!cartNoti || !cartNoti.enable) {
          window.Alpine?.store('xMiniCart')?.openCart?.();
        }
      } catch (error) {
        message.textContent = error.message || 'Es ist ein Fehler aufgetreten.';
        message.classList.add('is-error');
      } finally {
        window.updatingCart = false;
        spinner.hidden = true;
        updateUI();
      }
    });

    updateUI();
  };

  const boot = () => document.querySelectorAll('[data-canivoa-blog-buybox]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
